module.exports = __webpack_public_path__ + "static/media/key.374d080f.svg";